import * as React from 'react'
import { useSortable } from '@dnd-kit/sortable'
import { CSS } from '@dnd-kit/utilities'

import { AnalysisCard } from './AnalysisCard'
import { Team } from '../types'

export type SortableAnalysisCardProps = {
  id: number
  title: string
  teams: Team[]
  onAnchorClick?: () => void
}

export const SortableAnalysisCard: React.VFC<SortableAnalysisCardProps> = ({
  id,
  title,
  teams,
  onAnchorClick,
}) => {
  const {
    attributes,
    isDragging,
    listeners,
    setNodeRef,
    transform,
    transition,
  } = useSortable({ id })

  const style: React.CSSProperties = {
    opacity: isDragging ? 0.6 : 1,
    transform: CSS.Translate.toString(transform),
    transition,
  }

  return (
    <AnalysisCard
      ref={setNodeRef}
      id={id}
      title={title}
      teams={teams}
      style={style}
      dragHandleProps={{ ...attributes, ...listeners }}
      onAnchorClick={onAnchorClick}
    />
  )
}
